import { useMemo } from 'react';
import { IconButton, makeStyles } from '@material-ui/core';
import { ALL_ROUTES } from 'config/routes';
import permissions from 'config/permissions';
import { checkPermission } from 'helpers/checkPermissions';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { useDispatch, useSelector } from 'react-redux';
import { navigateToRoute } from '../../../../redux_store';

const useStyles = makeStyles((theme) => ({
  moreIcon: {
    width: 20,
    fill: 'rgba(255,255,255,0.71)',
  },
}));

const AccountMenu = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { en: { titles } } = useSelector((state) => state.i18n);
  const {
    metadata: {
      currentAccount,
      currentAccountPermissions,
    },
  } = useSelector((state) => state.user);

  const canManageAccountDetails = useMemo(
    () => checkPermission(
      currentAccountPermissions,
      permissions.ACCOUNT_PATCH,
    ),
    [currentAccountPermissions],
  );

  const handleAccountEdit = () => {
    dispatch(navigateToRoute({
      route: {
        path: ALL_ROUTES.account.edit.path,
        params: { currentAccountUuid: currentAccount.uuid },
        title: titles.editAccount,
        clearBreadcrumbs: true,
      },
    }));
  };

  return canManageAccountDetails ?
    <IconButton
      size="small"
      aria-controls="account-menu"
      aria-haspopup="true"
      onClick={handleAccountEdit}
      style={{
        marginLeft: 12,
      }}
    >
      <EditIcon className={classes.moreIcon} />
    </IconButton>
    : <></>;
};

export default AccountMenu;
